import React from 'react';
import { Helmet } from 'react-helmet';
import './apiPages.css';

import Footer from '../Footer';
import HeroComponentv2 from '../productComponent/hero/HeroComponentv2';
import MultiPanelCards from '../productComponent/benefits/MultiPanelCards';

// Import images
import api_hero from "../../assets/images/api/api-header-zapier.jpg";
import Llama_Watching from "../../assets/images/unauth/llama-watching-small.png";
import Llama_Music from "../../assets/images/unauth/llama-music-clay.png";

// Import images for MultiPanelCards
import org_pannel1 from "../../assets/images/api/zap-panel-1.jpg";
import org_pannel2 from "../../assets/images/api/zapier-panel-2.jpg";
import org_pannel3 from "../../assets/images/api/zapier-panel-3.jpg";


const ZapierAPI = () => {

  const heroData = {
    title: 'Zapier Integration',
    subtitle:
      'Automate video workflows by connecting Bumpups to 8,000+ apps—no code required.',
    buttonText: 'No Code Automation',
    imgSrc: api_hero,
    buttonLink: 'https://zapier.com/apps/bumpups/integrations',
    llamaWatching: Llama_Music,
    llamaReading: Llama_Watching
  };

  const multiPanelData = {
    headerText: 'Automate Everything Video',
    freeButtonText: 'Browse Zap Templates',
    freeButtonLink: 'https://zapier.com/apps/bumpups/integrations',
    buttons: [
      {
        title: '8,000+ Integrations',
        subtext:
          'Connect Bumpups to over 8,000 apps—from Google Sheets to Slack—to build end-to-end video workflows with no code.',
        image: org_pannel1,
      },
      {
        title: 'No-Code Setup',
        subtext:
          'Create smart automations in minutes. Simply pick a trigger, choose your AI-powered action, and hit “Turn on Zap.”',
        image: org_pannel2,
      },
      {
        title: 'Video Platforms',
        subtext:
        'Available now for YouTube, with support for Google Drive, Vimeo, Twitch, LinkedIn, X, and more on the roadmap.',
        image: org_pannel3,
      },
    ],
  };
  
  
  

  return (
    <div className="api-main-container">
      <Helmet>
        <title>Bumpups + Zapier | Automate Your Video Tasks</title>
        <meta
          name="description"
          content="Use Zapier to connect Bumpups video AI with 8,000+ apps—generate titles, descriptions, timestamps, and more without code."
        />
        {/* Load Zapier Elements */}
        <script type="module" src="https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.esm.js"></script>
        <link rel="stylesheet" href="https://cdn.zapier.com/packages/partner-sdk/v0/zapier-elements/zapier-elements.css"/>

      </Helmet>

      <HeroComponentv2 data={heroData} />

        {/* Embed Zapier workflow widget with padding */}
        <div className="zapier-padding">
            <zapier-workflow
            client-id="bJcktEC8YDvgYMcKcPSwPVnPW0RdVODZXuBUSsvc"
            theme="dark"
            intro-copy-display="hide"
            manage-zaps-display="hide"
            guess-zap-display="show"
            app-search-bar-display="show"
            app-limit={0}
            template-ids="255630021,255630023,255630024,255630025,255630027"
            zap-create-from-scratch-display="hide"
            />
        </div>

      <MultiPanelCards {...multiPanelData} />
      <Footer />
    </div>
  );
};

export default ZapierAPI;
